module.exports = __webpack_public_path__ + "img/tp2.15abc2e0.png";